import styled from '@emotion/styled';

export default styled('path')``;
